import {Search} from 'lucide-react'

type SearchInputProps = {
  value: string
  onChange: (value: string) => void
}

export const SearchInput = ({value, onChange}: SearchInputProps) => (
  <div className='space-y-2'>
    <label className='block text-sm font-medium text-gray-700'>Buscar permissão</label>
    <div className='relative'>
      <Search className='absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-blue-500' />
      <input
        type='text'
        placeholder='Título ou identificador técnico...'
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className='w-full rounded-xl border-2 border-gray-100 bg-gray-50 py-3 pl-12 pr-4 transition-all duration-200 hover:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200'
      />
    </div>
  </div>
)
